const locale = {
  pt: {
    translation: {
      BANNER_BUTTON: 'Ver detalhes',
      COURSE_RECOMMENDATION: 'Cursos recomendados pela comunidade',
      COURSE_NEW: 'Cursos Novos',
      COURSE_WATCH_MORE: 'Veja mais cursos',
      COURSE_MEMBERSHIP_TITLE: 'Tenha acesso Total com Premium',
      COURSE_MEMBERSHIP_SUBTITLE:
        'Se una a nossa comunidade Premium e acesse a mais de 500 cursos e mais de 9 carreiras',
      COURSE_MEMBERSHIP_BUTTON: 'Me interessa',
      COURSE_CAREERS_TITLE: 'Especializações',
      COURSE_CAREERS_WATCH_MORE: 'Explore mais especializações',
      COURSE_CERTIFICATIONS_TITLE: 'Certifique-se',
      COURSE_CERTIICATIONS_WATCH_MORE: 'Explora mais certificações',
      SHOW_ALL_COURSES: 'Mostrar todos os cursos',
      SEO_RECOMMENDED: 'Cursos recomendados pela comunidade',
      SEO_NEWS: 'Novos cursos on-line',
      SEO_FREE: 'Cursos online gratuitos',
      SEO_DISCOUNT: 'Cursos em oferta',
      FILTER: 'Seus Filtros',
      SORT_BY: 'Classificar',
      RESET_FILTERS: 'Limpar',
      RETURN: 'Retornar',
      CLEAN_FILTERS: 'Limpar Filtros',
      AD_TITLE1: 'Aproveite ',
      AD_TITLE2: '% de desconto na sua próxima compra!*',
      AD_MIN_AMOUNT: 'Valor mínimo',
      AD_DESCRIPTION:
        'Seu desconto será aplicado no momento da sua compra. Se aplica apenas a cursos e certificações.',
      AD_BUTTON: 'Ver catálogo',
      BECOME_PREMIUM: 'Aproveite',
      BECOME_PREMIUM_DESCRIPTION: 'Acesse todos esses cursos com descontos',
    },
  },
};

export default locale;
